import React, { useEffect, useContext } from "react";
import Context from "../Context";
export const FourOFour = () => {
  const { go } = Context();
  useEffect(() => {
    go("/");
  }, []);
  return <></>;
};
